import { Component, inject, SimpleChanges } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { DataService } from '../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { companies, companiesFinanciero, companiesReportesNorm, companiesRiesgoCredito, companiesRiesgoCreditoAT, companiesRiesgoLiquidez, companiesSegPresupuestal } from '../../shared/catalogos';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { ContenedorService } from '../../services/contenedor/contenedor.service';
import { ArraysOrder } from '../funciones/funcionesGenerales';
import { messages } from '../funciones/mensajes';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { getAsignacionesInst, getCuestionarioPorId, getEstatusHoja, getHojaRespuesta } from '../../services/Administrador/cuestionarios/query';
import { HttpHeaders } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { PlanificacionService } from '../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../services/gestion/indicadores/indicador.service';
import { ProyectosService } from '../../services/gestion/proyectos/proyectos.service';
import { TraduccionesInstitucionService } from '../../services/traducciones/traducciones-institucion.service';

@Component({
  selector: 'app-contenedor',
  templateUrl: './contenedor.component.html',
  styleUrl: './contenedor.component.css'
})
export class ContenedorComponent {
  dataService = inject(DataService); 
  #translate = inject(TranslateService);
  #router = inject(Router);
  #apollo = inject(Apollo);

  seleccion = '';

  #language = 'es';

  public modulosAct = [];
  private allocations = [];
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private access = [];
  private url: any;
  public planning = [];
  private planingId = 0;
  private selectPlannig: any = ''
  private sideNavActive = 'close';


  constructor(
    private auth: AuthService,
    private cookies: CookieService,
    private activateRoute: ActivatedRoute,
    private contenedorService: ContenedorService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private analytics: AnalyticsService,
    private traduccionesInstitucion: TraduccionesInstitucionService,

    private planificacionService: PlanificacionService,
    private objetivoService: ObjetivoService,
    private indicadorService: IndicadorService,
    private proyectosService: ProyectosService,
  ){
    this.analytics.startService(environment.googleAnalytics);
    // Si el usuario ya está logueado, setear su ID
    const currentUser = this.dataService;
    if (currentUser && environment.production) {
      this.analytics.setUserId(this.dataService.id, {
        user_properties: {
          role: this.dataService.role,
          email: this.dataService.user
        }
      });
    }


    this.#language = localStorage.getItem('language')//this.cookies.get('language');
    this.traduccionesInstitucion.configurar(this.#language, this.dataService.idInstitution)
    // this.#translate.setDefaultLang(this.#language);

    window.addEventListener('beforeunload', (e) => {
      const mod = this.#router.url.split('/')[2];
      const tab = this.#router.url.split('/')[3];

      if (
        localStorage.getItem('sinGuardar') === 'true' &&
        mod === 'cuestionarios' &&
        tab === 'cuestionarios-asignados'
      ) {
        e.preventDefault();
        e.returnValue = '';
      }
    });

    this.obtenerSelect('revisar');
    // Listener de cambio de eventos
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd){
        const currenUrl = event.urlAfterRedirects || event.url;
        if( currenUrl.includes('/administrador-gestion/alta-planes')
          || currenUrl.includes('/administrador-gestion/catalogos')
        ){
          this.obtenerSelect('revisar');
        }
      }
    });
  }

    // Métodos del WelcomeComponent
  public openMenu(drawer: any){
    const mod = `${this.#router.url}`.split('/')[2];
    const tab = `${this.#router.url}`.split('/')[3];
    if(
      localStorage.getItem('sinGuardar') === 'true' &&
      mod === 'cuestionarios' && 
      tab === 'cuestionarios-asignados'
    ){
      messages.infoMessageGraph(this.translate.instant('cues.cuestionarios.sin-guardar'));
      return ;
    }
    !drawer.opened?drawer.open():drawer.close();
  }

  private async getAccess(){
    const res = await firstValueFrom(
      this.contenedorService.getAccess(this.dataService.user)
    );
    
    if(res){
      this.access = [];
      for(const acc of res.access){
        this.access.push(`${acc}`);
      }
      if ( res.access.length === 0){
        this.access = ['all']
      }
    }else{
      this.access = ['no encontrado']
    }
  }

  obtenerSelect(act){
    const mod = this.activateRoute.snapshot['url'];
    if(act === 'cambio' && !this.dataService.role.toLowerCase().includes('administrador')){
      return;
    }
    if(mod.length > 1){
      if(mod[1].path === 'operative' || mod[1].path === 'operative-potencial'){
        this.operativeFunction(act)
      }else if(mod[1].path === 'riesgo-credito'){
        this.riesgoCredito(act)
      } else if(mod[1].path === 'financiero-alerta'){
        this.financieroAlerta(act);
      } else if(mod[1].path === 'formulacion' || mod[1].path === 'seguimiento' || mod[1].path === 'reportes' || mod[1].path === 'administrador-gestion'){
        this.sendToGestionEstrategica(act)
      } else if(mod[1].path == 'resultados'){ 
        this.getInformation(act);
      }else if(mod[1].path == 'riesgo-liquidez'){
        this.riesgoLiquidez(act);
      } else if(mod[1].path == 'proyecciones-financieras'){
        this.sendToProyecciones(act);
      } else if(mod[1].path == 'seguimiento-presupuestal'){
        this.sendToSegPresupuestal(act);
      } else if(mod[1].path === 'reportes-normativos'){
        this.reportesNorm(act);
      } else if(mod[1].path === 'clima-laboral'){
        this.sendToClimaLaboral(act);
      }
    }
  }
  
  // Envio plataforma operativo
  private async operativeFunction(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companies.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companies){
        inst.push(c.name)
      }
      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companies[result].id, {path: '/'});
        location.reload();
      }
    }
  }
  // Envio plataforma riesgos
  private async riesgoCredito(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companiesRiesgoCredito.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companiesRiesgoCredito){
        inst.push(c.name)
      }

      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companiesRiesgoCredito[result].id, {path: '/'});
        location.reload();
      }
    }
  }
  // Envio plataforma seguimiento-presupuestal
  private async sendToSegPresupuestal(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companiesSegPresupuestal.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companiesSegPresupuestal){
        inst.push(c.name)
      }

      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companiesSegPresupuestal[result].id, {path: '/'});
        location.reload();
      }
    }
  }
  private async financieroAlerta(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companiesFinanciero.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companiesFinanciero){
        inst.push(c.name)
      }

      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companiesFinanciero[result].id, {path: '/'});
        this.cookies.set('idPlanFin',companiesFinanciero[result].idPlantilla, {path: '/'});
        location.reload();
      }
    }
  }
  // Envio plataforma gestion
  private async sendToGestionEstrategica(acc){
    await this.getAccess();
    const mod = this.activeRoute.snapshot['_routerState'].url.split('/');
    const submodulo = mod[3];
    if(mod[2] !== 'administrador-gestion'){
      if(acc === 'revisar'){
        this.seleccion = this.cookies.get('nombreInstitucion');
      }else{
        messages.messageSaving(this.#translate.instant('acciones.espera'), '');
        const res = await this.planificacionService.getPlanificacionesGQL();
  
        this.planning = [];
        for(const plan of res){
          if(this.planAccess(plan.institution.id)){
            this.planning.push({
              id: plan.id,
              name: plan.name,
            });
          }
        }
        this.planning = ArraysOrder.orderNumber(this.planning, 'id')
        var plans: any = [];
        for(const plan of this.planning){
          plans.push(`${plan.name}`);
        }
        Swal.close();
        if(plans.length >0){

          const result = await messages.select(
            this.#translate.instant('gestion.seleccione-planeacion'),
            plans,
            this.#translate
          );
          if (result) {
            this.planingId = Number(this.planning[Number(result)].id);
            this.selectPlannig = this.planning[Number(result)].name;

            this.cookies.set('idInstitucion',`${this.planingId}` , {path: '/'});
            this.cookies.set('nombreInstitucion',this.selectPlannig, {path: '/'});
            
            location.reload();
          }
        }else{
          messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
        }
      }
    }else { 
      if(acc === 'revisar'){
        this.seleccion = this.cookies.get('nombreInstitucion');
      } else if(submodulo !== 'alta-planes') {
        try {
          messages.messageSaving(this.#translate.instant('acciones.espera'), '');
          const response = await firstValueFrom(this.contenedorService.getInstitutions());
          this.planning = [];
          for(const inst of response){
            if(this.planAccess(inst.id) && (inst.code === this.dataService.idInstitution || this.dataService.role === 'Administrador_AleemaRemake')){
              this.planning.push({
                id: inst.id,
                nombre: inst.name,
              });
            }
          }
          this.planning = ArraysOrder.orderNumber(this.planning, 'id');

          var Planeaciones: any = [];
          for(const plan of this.planning){
            Planeaciones.push(`${plan.nombre}`);
          }
          Swal.close();
          if(Planeaciones.length > 0){
            const result = await messages.select(
              this.#translate.instant('gestion.seleccione-institucion'),
              Planeaciones,
              this.#translate
            );
            if (result) {
              this.planingId = Number(this.planning[Number(result)].id);
              this.selectPlannig = this.planning[Number(result)].nombre;

              this.cookies.set('idInstitucion', `${this.planingId}`, { path: '/' });
              this.cookies.set('nombreInstitucion', this.selectPlannig, { path: '/' });
              
              location.reload();
            }
          }else{
            messages.infoMessageGraph(this.#translate.instant('gestion.institucion-no-encontrada'));
          }
        } catch (error) {
          messages.errorMessageGraph('Error al obtener las instituciones');
        }
      }
    }
  }
  // Envio plataforma proyecciones
  async sendToProyecciones(route){

  }

  private async reportesNorm(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companiesReportesNorm.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companiesReportesNorm){
        inst.push(c.name)
      }

      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companiesReportesNorm[result].id, {path: '/'});
        this.cookies.set('idPlanFin',companiesReportesNorm[result].idPlantilla, {path: '/'});
        location.reload();
      }
    }
  }
  
  private planAccess(id: any){
    if ( this.access[0] === 'all' || this.access.includes(id) || this.access[0] === 'no encontrado'){
      return true;
    }
    return false;
  }

  home(){
     // Lógica combinada de los métodos home()
    const mod = `${this.#router.url}`.split('/')[2];
    const tab = `${this.#router.url}`.split('/')[3];
    if(
      localStorage.getItem('sinGuardar') === 'true' &&
      mod === 'cuestionarios' && 
      tab === 'cuestionarios-asignados'
    ){
      messages.infoMessageGraph(this.translate.instant('cues.cuestionarios.sin-guardar'));
      return ;
    }
    this.cookies.delete('idInstitucion','/');
    this.cookies.delete('idPlanFin','/');
    this.cookies.delete('nombreInstitucion','/');
    localStorage.removeItem('cuestionario');
    localStorage.removeItem('answers');
    localStorage.removeItem('allocation');
    this.#router.navigateByUrl(`/app`);
  }

  logOut(){
    const mod = `${this.#router.url}`.split('/')[2];
    const tab = `${this.#router.url}`.split('/')[3];
    if(
      localStorage.getItem('sinGuardar') === 'true' &&
      mod === 'cuestionarios' && 
      tab === 'cuestionarios-asignados'
    ){
      messages.infoMessageGraph(this.translate.instant('cues.cuestionarios.sin-guardar'));
      return ;
    }
    localStorage.removeItem('cuestionario');
    localStorage.removeItem('answers');
    localStorage.removeItem('allocation');
    localStorage.removeItem('sinGuardar');    

    sessionStorage.clear();
    this.auth.logOut();
    this.cookies.deleteAll('/');
    location.assign(`/app`);
  }

  public validacionTableros(drawer: any){    
    const tablero = this.router.url.split('/')[this.router.url.split('/').length-1];
    const modulo = this.router.url.split('/')[2];
    if(modulo === 'formulacion'){// && this.sideNavActive === 'close'
      switch(tablero){
        case 'objetivos':
          this.validarObj(drawer);
        break;
        case 'indicadores-metas':
          this.validarInd(drawer);
        break;
        case 'proyectos-estrategicos':
          this.validarPro(drawer);
        break;
        default:
          drawer.toggle().then((sidenavIsOpen) => {
            this.sideNavActive = sidenavIsOpen; 
          });
        break;
      }
    }else{
      drawer.toggle().then((sidenavIsOpen) => {
        this.sideNavActive = sidenavIsOpen; 
      });
    }
  }
  /** Validación de los tableros */
  private async validarObj(drawer){
    messages.messageSaving(this.translate.instant('swal.eval'),this.translate.instant('swal.espe'));
    const idPlan = Number(this.cookies.get('idInstitucion'));
    try{
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(idPlan);
      const perspecId = this.obtenerPerspectivas(planeacionResponse, idPlan);
      var objetivos = [];
      for(const per of perspecId){
        const res = await this.objetivoService.getObjectivesByPerspectiveGQL(Number(per))
        objetivos = objetivos.concat(res);
      }
      const obj = this.obtenerObjetivos(objetivos, perspecId);

      var pond = 0, objsnP = '';
      for(const ob of obj){
        if(ob.weighing !== 0){
          pond = Number( ( pond + ob.weighing ).toFixed(2) );
        }else{
          objsnP += this.formatearTexto(ob.name);
        }
      }
      if(pond < 100 || pond > 100 || objsnP.length !== 0){
        Swal.close();
        var tit = '';
        if(objsnP){
          tit = this.translate.instant('swal.objEv');
        }else if( pond > 100 || pond < 100){
          tit = this.translate.instant('swal.noPond')
          objsnP += this.formatearTexto(this.translate.instant('swal.ponAc')+''+pond+' %');
        }
        this.finalizacionValidacion(tit, objsnP, drawer);
      }else{
        Swal.close();
        this.finalizacionCorrecta(drawer);
      }
    }catch(e){
      messages.errorMessageGraph(this.#translate.instant('swal.error'));     
    }
  }
  private async validarInd(drawer){
    messages.messageSaving(this.translate.instant('swal.eval'),this.translate.instant('swal.espe'));
    const idPlan = Number(this.cookies.get('idInstitucion'));
    try{
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(idPlan);
      const perspecId = this.obtenerPerspectivas(planeacionResponse, idPlan);
      var objetivos = [];
      for(const per of perspecId){
        const res = await this.objetivoService.getObjectivesByPerspectiveGQL(Number(per))
        objetivos = objetivos.concat(res);
      }
      const objec = this.obtenerObjetivos(objetivos, perspecId);
      const indicators = await Promise.all(
        objec.map(id => this.indicadorService.getIndicadoresByObjetiveGQL(Number(id.id)))
      );
      const indicadores = this.obtenerIndicadores(indicators.flat(), objec);
      var ponTot = 0, noPond = '', indic = 0;
      for(const obj of objetivos){
        for(const ind of indicadores){
          if(ind.objetiveId === obj.id){
            ponTot = Number( ( ponTot + Number(ind.ponderacion) ).toFixed(2) );
            indic++;
          }
        }
        if(indic != 0 && (ponTot<100 || ponTot >100)){
          noPond += this.formatearTexto(obj.name, ponTot);
        }
        ponTot = 0;
        indic = 0;
      }

      Swal.close();
      if(noPond != ''){
        let title = this.translate.instant('swal.indNo');
        this.finalizacionValidacion(title, noPond, drawer);
      }else{
        Swal.close();                  
        messages.succesMessageGraph(this.translate.instant('swal.ponder'));
        drawer.toggle().then((sidenavIsOpen) => {
          this.sideNavActive = sidenavIsOpen; 
        });
      }
    }catch(e){
      messages.errorMessageGraph(e);
    }
  }
  
  private async validarPro(drawer){
    messages.messageSaving(this.translate.instant('swal.eval'),this.translate.instant('swal.espe'));
    try{
    const idPlan = this.cookies.get('idInstitucion');
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(Number(idPlan));
      const perspecId = this.obtenerPerspectivas(planeacionResponse, idPlan);
      var objetivos = [];
      for(const per of perspecId){
        const res = await this.objetivoService.getObjectivesByPerspectiveGQL(Number(per))
        objetivos = objetivos.concat(res);
      }
      const objec = this.obtenerObjetivos(objetivos, perspecId);
      
      var noPond = '', proyec = 0, pondT = 0, pondD = 0;
      let ponTot = 0;
      var anio = moment().format('YYYY');
      const inicio = moment(planeacionResponse.initial_date), fin = moment(planeacionResponse.end_date)
      if( !moment(anio).isBetween(inicio, fin, 'year', "[]") ){
        moment(anio).isBefore(inicio, 'year')? anio = inicio.format('YYYY'):anio = fin.format('YYYY')
      }
      for(const obj of objetivos){
        const proyects = obj.projects.map(e => e.id);
        var projects = [];
        for (let i = 0; i < proyects.length; i += 10) {
          const batch = proyects.slice(i, i + 10);
          const results = await this.proyectosService.getProyectsGQL(batch);
          projects.push(...results);
        }

        for(const pro of projects){
          if (this.existeAnioValidacion(pro, anio)){
            pondD++;
            for(const pon of pro.weightingHistory){
              if(pon.period.split('-')[0] === anio+'' && pon.weighing !== 0){
                ponTot = Number( ( ponTot + pon.weighing ).toFixed(2) );
                proyec++;
                pondT++;
              }
            }
          }
        }
        if(pondD !== pondT){
          noPond += this.formatearTexto(obj.name,undefined,this.translate.instant('swal.proSi'));
        }else if( (proyec != 0 && ponTot !== 100)){
          noPond += this.formatearTexto(obj.name, ponTot);
        }
        pondD = 0;
        pondT = 0;
        ponTot = 0;
        proyec = 0;
      }
      if(noPond != ''){
        let title = this.translate.instant('swal.objNo');
        this.finalizacionValidacion(title, noPond, drawer);
      }else{
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.ponder'));
        drawer.toggle().then((sidenavIsOpen) => {
          this.sideNavActive = sidenavIsOpen; 
        });
      }

    }catch(e){
      messages.errorMessageGraph(e);
    }
  }

  private obtenerPerspectivas(response, idPlan){
    var perspecId = [];
    for(const per of response.perspectives){
      perspecId.push(per.id)
    }
    return perspecId;
  }
  private obtenerObjetivos(response, perspecId){
    var obj = [];
    for(const per of perspecId){
      let ob = response.filter( objec => Number(objec.perspective.id) === Number(per));
      if( ob ){
        obj = obj.concat(ob);
      }
    }
    return obj;
  }
  private obtenerIndicadores(response, objetivos){
    var aux = [], aux2 = [], indicadores = [];
    for(const ind of response){
      for(const obj of objetivos){
        if(obj.id === ind.objective.id){
          aux.push({
            id: ind.id,
            ponderacion: ind.weighing,
            nombre: ind.name,
            objetiveId: ind.objective.id,
          });
        }
      }
    }
    indicadores = aux;
    indicadores = this.ordenamientoPer(indicadores);
    indicadores = this.ordenamientoInd(indicadores);
    return indicadores;
  }
  private obtenerProyectos(response, objetivos){
    var aux = [], proyectos = [];
    for(const pro of response){
      for( const ob of objetivos){
        if(pro.objectives.length !== 0 && pro.objectives[0].id === ob.id){
          var objectiveid = pro.objectives[0].id;
          /*for(const objid of pro.objectives){
            objectiveid.push(objid.id)
          }*/

          var estrategiaId: any = [];
          for(const estId of pro.strategies){
            estrategiaId.push(estId.id)
          }
          aux.push({
            nombre: pro.name,
            ponderacion: pro.historicWeighing,
            objetiveId: objectiveid, 
            programasId: estrategiaId,
            responsableId: pro.responsible.id,
            id: pro.id,
            descripcion: pro.description,
            actividades: pro.activities,
          });
          break;
        }
      }
    }
    return aux;
  }
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoInd(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.objetiveId) > Number(b.objetiveId)) {
        return 1;
      }
      if (Number(a.objetiveId) < Number(b.objetiveId)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private formatearTexto(texto: string, pond?: number, texto2?: string){
    var linea = '';
    if(pond !== undefined){
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+'</span><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt"> - </span> <span>'+ this.translate.instant('swal.ponTot') +pond+"%</span></div>"; 
    }else if(texto2 !== undefined){
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+'</span><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt"> - </span> <span>'+texto2+"</span></div>"; 
    }else{
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+"</span></div>"
    }
    return linea;
  }
  private existeAnioValidacion(pro: any, anio){
    const fechas = this.obtenerFechasPro(pro);
    if(fechas[1] !== undefined && fechas[0] !== undefined){
      if( moment(anio).isBetween(fechas[0], fechas[1], 'year', '[]') ){
        return true;
      }
      return false;
    }else{
      return false;
    }
  }
  private obtenerFechasPro(pro){
    var fecha_fin = undefined;
    var fecha_ini = undefined;
    for(const act of pro.activities){
      const initDate = moment(act.initial_date.split('T')[0]);
      const endDate = moment(act.end_date.split('T')[0]);
      if(fecha_ini === undefined || fecha_ini.isSameOrBefore(initDate)){
        fecha_ini = initDate.clone();
      }
      if(fecha_fin === undefined || fecha_fin.isSameOrAfter(endDate)){
        fecha_fin = endDate.clone();
      }
    }
    return [fecha_ini, fecha_fin]
  }
  private async finalizacionValidacion(title, texto, drawer){
    texto += '<br/><div style="text-aling: center;font-weight: 500;">'+this.translate.instant('swal.cont')+'</div>';
    const result = await messages.confirmationSave(
      title,
      texto,
      this.translate
    );
    if (result) {
      drawer.toggle().then((sidenavIsOpen) => {
        this.sideNavActive = sidenavIsOpen; 
      });
    }
  }
  private finalizacionCorrecta(drawer) {
    Swal.fire({
      title: this.translate.instant('swal.ponder'),
      text: '',
      icon: 'success',
      showConfirmButton: false,
      timer: this.dataService.time,
      didClose: () => {
        drawer.toggle().then((sidenavIsOpen) => {
          this.sideNavActive = sidenavIsOpen; 
        });
      }
    });
  }

  public cambioLenguaje(idioma: string){
    this.translate.setDefaultLang(idioma);
    // this.cookies.set('language', idioma, {path: '/'});
    localStorage.setItem('language', idioma);
    this.#language = idioma;
  }
  escritura(){
    const url = this.activateRoute.snapshot['url']
    if(url.length !== 1 && url[1].path === 'resultados'){
      // Reemplazo de localStorage por cookies
      const all = JSON.parse(this.cookies.get('allocation'));
      return `${all.questionary.name} | ${this.printDate(all.start_date)}`;
    }
    return '';
  }
    public printDate(date: any){
    return moment(date).format('MMM-YY')
  }
  public async getInformation(acc){
    // await this.getAccess();
    if(acc === 'revisar'){
      this.seleccion = this.cookies.get('nombreInstitucion');
    }else{
      messages.messageSaving(this.translate.instant('acciones.espera'),'')
      try{
        const allocations = await firstValueFrom(
          this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
            query: getAsignacionesInst,
            context: { headers: this.headers, },
            }).valueChanges.source
        );
    
        const arrayAllocations = allocations.data.availableSurveys; 
        this.allocations = [];
        var nameAlloc = [];
        for(const all of arrayAllocations){
          if(this.dataService.role === 'Rol_Administrador_cuestionarios' || all.institution_id === this.dataService.idInstitution){
            try{
              const answerSheet = await firstValueFrom(
                this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
                  query: getEstatusHoja,
                  context: { headers: this.headers, },
                  variables: { allocationId: Number(all.id)},
                  fetchPolicy: 'no-cache',
                }).valueChanges.source 
              );
        
              if(answerSheet.data.findAnswerSheet.status === 'completed' || all.status === 'closed'){
                this.allocations.push(all);
                nameAlloc.push(all.questionary.name);
              }
            }catch(err){}
          }
        }
        if(this.allocations.length === 0){
          Swal.close();
          setTimeout(() =>{
            messages.infoMessageGraph( this.translate.instant('cues.resultados.no-informacion') );
          }, 100);
          return;
        }
        var guardo = false;
    
        const result = await messages.select(
          this.#translate.instant('acciones.seleccione-cuestionario'),
          nameAlloc,
          this.#translate
        );
        if (result) {
          this.cookies.set('nombreInstitucion',nameAlloc[result], {path: '/'});
          guardo = true;
        }
    
        if(guardo){
          messages.messageSaving(this.translate.instant('acciones.espera'),'')
          try{
            const res = await firstValueFrom(
              this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
                query: getHojaRespuesta,
                context: { headers: this.headers, },
                variables: { allocationId: Number(this.allocations[result].id) }
              }).valueChanges.source
            );
      
            var answersSheet = [];
            for(const r of res.data.findAnswerSheet.answers){
              answersSheet.push({idQuestion: r.question.id, idAnswer: r.answerOption.id})
            }
      
            const res2 = await firstValueFrom(
              this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
                query: getCuestionarioPorId,
                context: { headers: this.headers, },
                fetchPolicy: 'no-cache',
                variables: {
                  args: {
                    relations: {
                      loadRelations: "FULL"
                    },
                    filter: {
                      operator: "AND",
                      conditions: [
                        {
                          field: "id",
                          operator: "EQUAL",
                          value: this.allocations[result].questionary.id
                        }
                      ]
                    },
                  },
                }
              }).valueChanges.source
            );
    
            localStorage.setItem('answers', JSON.stringify(answersSheet));
            localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
            localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));
    
            Swal.close();
            location.reload();
          }catch(err){
            messages.errorMessageGraph(err);
          }
        }
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }
  }

  // Envio plataforma clima laboral
  private async sendToClimaLaboral(acc){
    if(acc === 'revisar'){
      this.seleccion = this.cookies.get('nombreInstitucion');
      return;
    }
    messages.messageSaving(this.#translate.instant('acciones.espera'), '');
    try{
      const allocations = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
          fetchPolicy: 'no-cache',
        }).valueChanges.source
      );
      const arrayAllocations = allocations.data.availableSurveys;
      this.allocations = [];
      var nameAlloc = [];
      for(const all of arrayAllocations){
        //los cuestionarios de encuestas de ambiente y clima laboral no se muestran en este modulo(clima laboral)
        //caso especial para el rol Administrador_Planeacion_ClimaLaboral que puede ver todos los cuestionarios de clima laboral
        //aplica en menu.component, inicio.component y contenedor.component
        if(
          (this.dataService.role === 'Administrador_AleemaRemake' || this.dataService.role === 'Administrador_Planeacion_ClimaLaboral' || all.institution_id === this.dataService.idInstitution) &&
          all.questionary.allowMultipleAnswers && all.status === 'closed' && !all.questionary.name.toLowerCase().includes('encuesta de ambiente y clima laboral')
        ){
          this.allocations.push(all);
          nameAlloc.push(all.questionary.name);
        }
      }
      if(this.allocations.length === 0){
        Swal.close();
        setTimeout(() =>{
          messages.infoMessageGraph( this.#translate.instant('cues.resultados.no-informacion') );
        }, 100);
        return;
      }

      const result = await messages.select(
        this.#translate.instant('acciones.seleccione-cuestionario'),
        nameAlloc,
        this.#translate
      );
      if(!result){
        Swal.close();
        return;
      }
      this.cookies.set('nombreInstitucion', nameAlloc[result], {path: '/'});

      messages.messageSaving(this.#translate.instant('acciones.espera'), this.#translate.instant('acciones.cargando'));
      const res2 = await firstValueFrom(
        this.#apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionarioPorId,
          context: { headers: this.headers, },
          fetchPolicy: 'no-cache',
          variables: {
            args: {
              relations: { loadRelations: "FULL" },
              filter: {
                operator: "AND",
                conditions: [
                  { field: "id", operator: "EQUAL", value: ''+this.allocations[result].questionary.id }
                ]
              },
            },
          }
        }).valueChanges.source
      );
      localStorage.setItem('allocation', JSON.stringify(this.allocations[result]));
      localStorage.setItem('cuestionario', JSON.stringify(res2.data.questionnaires[0]));

      Swal.close();
      location.reload();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  // Envio plataforma riesgo-liquidez
  private async riesgoLiquidez(acc){
      // LOG A: Inicio de la función y acción recibida

      if(acc === 'revisar'){
          // LOG B: Bloque 'revisar'
          let id = this.cookies.get('idInstitucion');
          
          let com = companiesRiesgoLiquidez.find( c => c.id === id); 
          
          this.seleccion = com.name;
      }
      else if(acc === 'cambio'){
          // LOG C: Bloque 'cambio'
          var inst = [];
          for(const c of companiesRiesgoLiquidez){
              inst.push(c.name)
          }

          const result = await messages.select(
            this.#translate.instant('swal.seleccione-institucion'),
            inst,
            this.#translate
          );
          if (result) {
            this.cookies.set('idInstitucion',companiesRiesgoLiquidez[result].id, {path: '/'});
            this.cookies.set('idPlanFin',companiesRiesgoLiquidez[result].idPlantilla, {path: '/'}); 
            location.reload();
          }
      }
  }
  private async seguimientoPresupuestal(acc){
    if(acc === 'revisar'){
      let id = this.cookies.get('idInstitucion');
      let com = companiesSegPresupuestal.find( c => c.id === id);
      this.seleccion = com.name;
    }else if(acc === 'cambio'){
      var inst = [];
      for(const c of companiesSegPresupuestal){
        inst.push(c.name)
      }

      Swal.fire({
        title: this.#translate.instant('swal.seleccione-institucion'),
        input: 'select',
        inputOptions: inst,
        inputPlaceholder: this.#translate.instant('swal.seleccione'),
        showCancelButton: true,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.#translate.instant('swal.acep'),
        cancelButtonText: this.#translate.instant('swal.cerr'),
        reverseButtons: true,
        customClass: {
          actions: 'aleema-swal-actions',
          confirmButton: 'aleema-swal-confirm',
          cancelButton: 'aleema-swal-cancel',
          input: 'aleema-swal-select'
        },
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if(value){
              resolve('');
            }else{
              resolve(this.#translate.instant('swal.seleccione-institucion'));
            }
          })
        }
      });
      const result = await messages.select(
        this.#translate.instant('swal.seleccione-institucion'),
        inst,
        this.#translate
      );
      if (result) {
        this.cookies.set('idInstitucion',companiesSegPresupuestal[result].id, {path: '/'});
        location.reload();
      }
    }
  }

}
